export default __webpack_public_path__ + "static/media/country-graph.0add6bab.svg";